export { default as GDMSecureImage } from './GDMSecureImage';

export type {
  GDMSecureAvatarProps,
  GDMSecureImageComponent,
  GDMSecureImgProps,
} from './GDMSecureImage.type';
